import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Opacity } from "@faire/web/slate/Color";
import { Column } from "@faire/web/slate/Layout";
import { Modal } from "@faire/web/slate/Modal";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useState } from "react";
import styled from "styled-components";

import { IDottedTooltipProps } from "./SharedTooltipProps";

const DottedUnderlineText = styled(Typography)`
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-color: ${Core.text.default + Opacity.O_50};
  text-underline-offset: 3px;
`;

const ModalContentWrapper = styled(Column)`
  padding: ${getSpacing(0, "3x")};
  width: 100%;
  height: 100%;
`;

const ButtonContainer = styled(Column)`
  flex-grow: 1;
`;

export const MobileDottedTooltip: React.FC<IDottedTooltipProps> = ({
  text,
  tooltipTitle,
  tooltipText,
  tooltipCTA,
  tooltipCTALink,
  openCTAInNewTab,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <DottedUnderlineText variant="paragraphSansMedium" onClick={openModal}>
        {text}
      </DottedUnderlineText>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        contentStyle={{ height: "min-content", alignSelf: "end" }}
        padding="0"
      >
        <ModalContentWrapper>
          <Spacer size="3x" />

          <Typography variant="pageHeaderSerifRegular">
            {tooltipTitle}
          </Typography>

          <Spacer size="1x" />

          <Typography>
            {tooltipText}
            {tooltipCTA ? (
              <>
                {" "}
                <Button
                  variant="tertiary"
                  tertiaryColor={Core.surface.default}
                  linkTo={tooltipCTALink}
                  target={openCTAInNewTab ? "_blank" : undefined}
                >
                  {tooltipCTA}
                </Button>
              </>
            ) : null}
          </Typography>
          <Spacer size="3x" />

          <ButtonContainer>
            <Button variant="primary" onClick={closeModal}>
              <StrictLocalMsg
                id="CFEXKS"
                defaultMessage="Close"
                description={{
                  text: "Close a user interface component.",
                }}
              />
            </Button>
          </ButtonContainer>
          <Spacer size="4x" />
        </ModalContentWrapper>
      </Modal>
    </>
  );
};
